export const SESSION_EXPIRED = 'session_expired';
export const LEFT_DIR = 'left';
export const RIGHT_DIR = 'right';
export const DISABLE_SWIPE = 'disable-swipe';
export const TRAINING_MODE_EMPLOYEE_NUMBER = '1';
export const AVIATIONWEATHER_ERROR = 'aviationweather-error';
